
define('app/dashboard/leagues/instances/views/fantTeamDelView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/fantasyTeamModel',
	'known/models/productTypeModel'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		FantasyTeamModel,
		ProductTypeModel){


	var RemoveTeamFooterView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			
			this.showDeleteForm();
			
			this.listenTo(this.event, 'default', this.showDeleteForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showDeleteForm);
			this.listenTo(this.event, 'success', this.showDeleteForm);
			
			_.bindAll(this, 'submitDeleteForm');
			
			$(this.el).find(".removeTmFormSubmit").on('click', this.submitDeleteForm);
		},
		
		hideAll: function () {
			this.$(".removeTmFormSubmit").hide();
			this.$(".removeTmFormCancel").hide();
		},
		
		submitDeleteForm: function () {
			this.event.trigger("save");
		},
		
		showDeleteForm: function () {
			this.hideAll();
			this.$(".removeTmFormSubmit").show();
			this.$(".removeTmFormCancel").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var RemoveTeamContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.fantTeam = options.fantTeam;
			this.prodType = options.prodType;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.deleteTeam);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.removeTeamForm);
			this.listenTo(this.event, 'success', this.removeTeamForm);
		},
		
		deleteTeam: function(event) {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;				
				this.fantTeam.destroy({success: this.successCallback, error: this.errorCallback, wait: true});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
		},
		
		removeTeamForm: function () {
			this.hideAll();
			$(this.el).show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var RemoveTeamMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.remSuccess);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$(".removeTmBodyMessageError").hide();
			this.$(".removeTmBodyMessageProcessing").hide();
			this.$(".removeTmBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".removeTmBodyMessageError").show();
		},
		
		remSuccess: function () {
			this.hideAll();
			//$(this.el).show();
			//this.$(".removeTmBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".removeTmBodyMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var RemoveTeamView = Backbone.View.extend({
		initialize: function(options) {		
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.fantTeam = options.fantTeam;
			this.prodType = options.prodType;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			
			this.message = new RemoveTeamMessageView({el: this.$(".removeTmBodyMessage"), event: this.event});
			this.content = new RemoveTeamContentView({
					el: this.$(".removeTmBodyContent"), 
					event: this.event,
					submittedData : this.submittedData,
					userModel: this.userModel, 
					lgInstance: this.lgInstance,
					fantTeam: this.fantTeam,
					prodType: this.prodType});
			this.footer = new RemoveTeamFooterView({el: this.$(".removeTmFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			this.listenTo(this.lgInstance, 'change:draftStatus', this.updateVisuals);
			
			//Setup Form open/hide
			var remTmOpenBtn = this.$(".removeTmOpen");
			var remTmCloseBtn = this.$(".removeTmFormCancel");
			
			remTmOpenBtn.on('click', {}, this.showView);
			remTmCloseBtn.on('click', {}, this.hideView);
		},
		
		render: function () {
			this.event.trigger("default");
			this.updateVisuals();
			return this;
		},
		
		updateVisuals: function() {
			//Determine whether to show the Remove Team form button
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get("draftStatus") == "SETUP"
					&& this.prodType.get('active')){
				this.$(".removeTmOpen").show();
			} else {
				this.$(".removeTmOpen").hide();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$(".removeTmOpen").show();
			this.$(".removeTmBodyContent").slideUp();
		},
		
		showView: function() {
			this.$(".removeTmOpen").hide();
			this.$(".removeTmBodyContent").slideDown();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				this.fantTeam.destroy();
				
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function () {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}

			this.$(".removeTmOpen").show();
			this.$(".removeTmBodyContent").hide();
		},
	    
	    destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return RemoveTeamView;  
});